export const getParam = (name: string, href?: string): string => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let realparams = decodeURIComponent(window.location.search.substr(1));
  if (href && href.indexOf("?") > -1) {
    realparams = href.split("?")[1];
  }
  const r = realparams.match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return "";
};

export const getCurrentHost = () => {
  const matchHost = window.location.host.match(/\w+\.\w+$/)?.[0];
  return matchHost || "37games.com";
};

export const debounce = (fn: Function, duration = 800) => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const debounce = (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
      timer = undefined;
    }, duration);
  };

  return debounce;
};

export const throttle = (fn: Function, duration = 800) => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const throttle = (...args) => {
    if (timer) {
      return;
    }
    timer = setTimeout(() => {
      fn(...args);
      timer = undefined;
    }, duration);
  };

  return throttle;
};

export const getMainHost = (): string => {
  return window.location.host.split(":")[0].replace(/[a-zA-Z0-9]*\./, "");
};

export const getBranch = () => {
  return window.location.hostname.split(".")[1];
};

// 获取当前平台
export const getPlatform = (): string => {
  let branch = getBranch();
  let platformMap: Record<string, string> = {
    gm99: "gm99",
  };
  return platformMap[branch] || "global";
};

export const initViewport = () => {
  let metaEl = document.querySelector("#viewportMeta");
  let content =
    "width=device-width,initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no,viewport-fit=cover,height=" +
    window.innerHeight;
  metaEl.setAttribute("name", "viewport");
  metaEl.setAttribute("content", content);
};

export const setBg = (path: string): string => {
  return `background-image:url(${path}); background-size: cover; background-repeat: no-repeat;`;
};

export const getDuration = (startTime) => {
  const endTime = new Date();
  const duration = Math.floor((endTime - startTime) / 1000);
  return duration;
};

// 链接添加参数
export const addUrlParams = (params, href?: string) => {
  try {
    const url = new URL(href || window.location.href);
    for (let k in params) {
      const paramValue =
        typeof params[k] === "string" ? params[k] : JSON.stringify(params[k]);
      url.searchParams.set(k, paramValue);
    }
    return url.href;
  } catch (error) {
    console.error("Error occurred while adding URL params:", error);
    return href || window.location.href;
  }
};

export const justifyDeviceType = () => {
  const userAgent = window.navigator.userAgent;
  const ua = userAgent.toLowerCase();
  const platform = {
    isAndroid: function () {
      return ua.indexOf("android") > -1;
    },
    isIOS: function () {
      return ua.indexOf("iphone") > -1;
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i);
    },
    isIpad: function () {
      var NPlatform = navigator.platform;
      return (
        /iPad/gi.test(NPlatform) ||
        (NPlatform === "MacIntel" &&
          navigator.maxTouchPoints > 1 &&
          !window["MSStream"])
      );
    },
    isPhone: function () {
      return this.isAndroid() || this.isIOS() || this.isWinPhone();
    },
    isIE11: function () {
      return (
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1
      );
    },
    isEdge: function () {
      return userAgent.indexOf("Edge") > -1;
    },
  };
  return platform;
};
